import { render } from "./VpsId.vue?vue&type=template&id=3918c9f4"
import script from "./VpsId.vue?vue&type=script&lang=js"
export * from "./VpsId.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__